module.exports = __webpack_public_path__ + "static/keytruda-dosing-mobile-3f0dc8974dc98d9a42d61f430a0988b2.png";